// extracted by mini-css-extract-plugin
export default {"modal":"NewAddress_modal__IwSBf","checkBox":"NewAddress_checkBox__O5Vxt"};